import React from 'react';

const Skipped = props => {
  const { isCurrentUser, skipReason } = props;
  const skippedMessage = () => {
    if (!isCurrentUser) {
      return t('questions.question.skipped.grader_video_skipped');
    }
    return t('questions.question.skipped.learner_skipped');
  };
  const FORMATTED_REASONS = {
    webcam_microphone_issue: t(
      'practice.on_demand_practice.audio_recording.skip_recording.reason_types.webcam_microphone',
    ),
    unable_to_start_recording: t(
      'practice.on_demand_practice.audio_recording.skip_recording.reason_types.unable_to_record',
    ),
    recorded_media_taking_too_long_to_process: t(
      'practice.on_demand_practice.audio_recording.skip_recording.reason_types.recorded_too_long_to_process',
    ),
    uploaded_media_taking_too_long_to_process: t(
      'practice.on_demand_practice.audio_recording.skip_recording.reason_types.uploaded_too_long_to_process',
    ),
    unable_to_process_media: t(
      'practice.on_demand_practice.audio_recording.skip_recording.reason_types.unable_to_process',
    ),
    other: t(
      'practice.on_demand_practice.audio_recording.skip_recording.reason_types.other',
    ),
    default: t(
      'practice.on_demand_practice.audio_recording.skip_recording.reason_types.default',
    ),
  };

  return (
    <em>
      {skippedMessage()}
      <div className="mt-8">
        {t('questions.question.skipped.reason')}
        {skipReason ? FORMATTED_REASONS[skipReason] : FORMATTED_REASONS.default}
      </div>
    </em>
  );
};

export default Skipped;
